/* eslint-disable no-mixed-spaces-and-tabs */
import { useCallback, useEffect, useState } from 'react';
import {
	Tabs,
	Tab as MUITab,
	styled,
	IconButton,
	MenuItem,
	Divider,
	Box,
	CircularProgress
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import Typography from '../typography/typography';
import Menu from '../menu/menu';
import AddPage from './components/add-page';
import PageAction from './components/page-action';
import Tooltip from '../tooltip/Tooltip';
import { IPage } from '../../@types/page';
import { defaultPageState } from '@erpsquad/common/runtime';
import { usePages } from '@erpsquad/common/runtime';
import Button from '../button/button';
import _ from 'lodash';
import { Save, Share } from '@mui/icons-material';
import './page-navigator.scss';
import React from 'react';

const StyledTabs = styled(Tabs)(() => ({
	minHeight: 'fit-content',

	'.MuiTabs-indicator': {
		height: '0px !important'
	},
	'& .MuiTabs-flexContainer': {
		gap: '4px'
	}
}));

const StyledTab = styled(MUITab)(({ theme: { palette } }) => ({
	minHeight: '2rem',
	textTransform: 'none',
	padding: '0rem 1rem',
	minWidth: 'fit-content',
	borderRadius: 4,
	'&.Mui-selected': {
		background: palette.theme?.primary[100],
		color: palette.theme?.primary[700],
		borderTop: `2px solid ${palette.theme?.primary[700]}`
	},
	'.MuiIconButton-root': {
		padding: '0rem'
	},
	"&:hover": {
		background: palette.theme?.primary[100]
	}
}));

const title = `successfully created, complete with your saved filters, sorting options, and views.`;

export interface IPageNavigator {
	pages: IPage[];
	setPages: React.Dispatch<React.SetStateAction<IPage[]>>;
	currentPage: string | number;
	setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
	sharedPages: any;
	resource: string;
	handlePageDelete: (pages: any[]) => void;
	isPageSaving?: boolean;
}

export const PageNavigator = ({
	// sharedPages,
	resource,
	// handlePageDelete
}: IPageNavigator) => {
	const { pages, setPages, setActivePage, activePage, savePages, setIsChanged, isSaving, generatedColumns, sharedPages, isChanged, deletePage, isCreatePage, setIsCreatePage, addOrDeletePage } = usePages();
	const shareTitle = (owner) => `shared by ${owner}`;
	const [isActionsMenuOpen, setIsActionsMenuOpen] =
		useState<null | HTMLElement>(null);
	const [page, setPage] = useState<IPage>();

	const [isAllPagesMenuOpen, setIsAllPagesMenuOpen] =
		useState<null | HTMLElement>(null);

	const handleChangePage = (_: React.SyntheticEvent, newValue: number) => {
		const pg = pages.find((p) => p?._id == newValue);
		setActivePage(pg);
	};

	const handleOpenActionsMenu = (
		event: React.MouseEvent<HTMLButtonElement>,
		clickedPage: IPage
	) => {
		event.stopPropagation();
		setPage(clickedPage);
		setIsActionsMenuOpen(event.currentTarget);
	};
	const handleCloseActionsMenu = () => setIsActionsMenuOpen(null);

	const handleOpenAllPagesMenu = (
		event: React.MouseEvent<HTMLButtonElement>
	) => {
		event.stopPropagation();
		setIsAllPagesMenuOpen(event.currentTarget);
	};
	const handleCloseAllPagesMenu = () => setIsAllPagesMenuOpen(null);

	const handleChangePageFromMenu = (val: number) => {
		setActivePage(val);
		handleCloseAllPagesMenu();
	};

	const handleAddPage = (newPage: IPage) => {
		const nPage = {
			...defaultPageState,
			...newPage,
			name: newPage.name,
			visible_columns: generatedColumns.columns,
			column_order: _.uniq(generatedColumns.orderKeys),
			_id: pages.length + 1,
			active_view: 'Table',
			views: [{
				label: 'Table',
				position: 0
			}]
		};
		const updatedPages: any = [
			...pages,
			...[nPage]
		];
		setActivePage({ ...nPage });
		setPages([...updatedPages]);
		setIsCreatePage(true)

	};

	const handlePageDeleteFunction = (pages: any[]) => {

		deletePage(pages)
	}


	const handleAddOrdeletePage = useCallback(async () => {
		if (isCreatePage) {
			const res = await addOrDeletePage();
			if (res?.status_code === 200) {
				setPages(res?.data?.pages);
				setIsChanged(false)
			}
		}
		setTimeout(() => {
			setIsCreatePage(false);

		}, 2000)
		//eslint-disable-next-line
	}, [isCreatePage])

	useEffect(() => {
		handleAddOrdeletePage()
		//eslint-disable-next-line
	}, [handleAddOrdeletePage])

	return (
		<Box display="flex" gap={2} alignItems={'center'} className='page-navigator-container'>
			<Box
				display={'flex'}
				className='page-navigator'
				sx={{ display: 'flex', opacity: isSaving ? 0.5 : 1 }}>
				<IconButton
					// size='small'
					onClick={handleOpenAllPagesMenu}
					disabled={isSaving}>
					<MenuIcon fontSize='small' />
				</IconButton>
				<StyledTabs
					value={activePage?._id}
					variant='scrollable'
					onChange={handleChangePage}
					aria-label='basic tabs example'>
					{pages?.map((page) => (
						<StyledTab
							iconPosition='end'
							disableRipple
							key={page}
							icon={
								<IconButton
									size='small'
									edge='end'
									onClick={(e) => handleOpenActionsMenu(e, page)}
									disabled={isSaving}>
									<KeyboardArrowDown fontSize='small' color={activePage?._id === page?._id ? 'primary' : undefined} />
								</IconButton>
							}
							label={
								<Tooltip
									title={`The '${page.name}' page has been  ${page?.isShared ? shareTitle(page?.owner) : title}`}
									key={page._id}
									placement='top'
									arrow>
									<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
										{page?.isShared && <Share sx={{ fontSize: '20px', color: '#4AC08C' }} />}
										<span>{page.name}</span>
									</Box>
								</Tooltip>
							}
							value={page?._id}
						/>
					))}
				</StyledTabs>

				<Divider
					orientation='vertical'
					variant='middle'
					flexItem
					sx={{
						ml: 2,
						borderWidth: '1px'
					}}
				/>
				<Box display="flex" alignItems={'center'}>
					<AddPage
						pages={pages}
						handleAddPage={handleAddPage}
						sharedPages={sharedPages}
					/>
				</Box>

				<PageAction
					open={isActionsMenuOpen}
					onClose={handleCloseActionsMenu}
					page={page}
					setPages={setPages}
					setCurrentPage={setActivePage}
					pages={pages}
					resource={resource}
					handlePageDelete={handlePageDeleteFunction}
				/>

				<Menu
					open={Boolean(isAllPagesMenuOpen)}
					anchorEl={isAllPagesMenuOpen}
					onClose={handleCloseAllPagesMenu}>
					{pages?.map((page) => (
						<MenuItem
							selected={page._id === activePage?._id}
							key={page._id}
							onClick={() => handleChangePageFromMenu(page)}>
							<Typography color='theme.secondary.1000' type='s4'>
								{page.name}
							</Typography>
						</MenuItem>
					))}
				</Menu>
			</Box>
			<Box display="flex" alignItems={'center'}>
				<Button
					size='small'
					variant='contained'
					onClick={() => savePages()}
					// sx={{fontWeight:600, marginBottom:'2px',px:3}}
					endIcon={
						isSaving ? <CircularProgress size={15} color='inherit' /> : <Save fontSize='small' />
					}
					disabled={!isChanged || isSaving}>
					Save
				</Button>
			</Box>
		</Box>
	);
};

export default PageNavigator;
